import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import { obj } from '@/util'
import { _tenant, _game } from "@/state";

export const TenantRoutes = {

	UpdateTenantAppearance: async (data) => {
		data._method = 'PUT'
		let tenant = _tenant().slug
		return await api().post(getRoute('api.tenantAppearance.update', { tenant }), obj.objToFormData(data))
	},
	UpdateTenantData: async (data) => {
		data._method = 'PUT'
		let tenant = _tenant().slug
		return await api().post(getRoute('api.tenantData.update', { tenant }), obj.objToFormData(data))
	},
	UpdateTenantArena: async (data) => {
		data._method = 'PUT'
		let tenant = _tenant().slug
		return await api().post(getRoute('api.tenantArena.update', { tenant }), obj.objToFormData(data))
	},

}

export const ResidentsRoutes = {

	GetAllResidents: async (args) => {
		args.tenant = args.tenant || _tenant().slug
		return await api().get(getRoute('api.residents.index', args));
	},

	GetResident: async ({ tenant, resident, game }) => {
		tenant = tenant || _tenant().slug
		let sprint = _game().sprint ? _game().sprint.id : null;
		return await api().get(getRoute('api.residents.show', { tenant, resident, game, sprint }));
	},

	CreateResident: async ({ tenant, resident }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.residents.store', { tenant }), obj.objToFormData(resident));
	},

	UpdateResident: async ({ tenant, resident }) => {
		tenant = tenant || _tenant().slug
		resident._method = 'PATCH'
		return await api().post(getRoute('api.residents.update', { tenant, resident }), obj.objToFormData(resident));
	},

	DeleteResident: async ({ tenant, resident }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.residents.destroy', { tenant, resident }));
	}

}

export const InvitationsRoutes = {

	GetAllTenantInvitations: async (args) => {
		args.tenant = args.tenant || _tenant().slug
		return await api().get(getRoute('api.invitations.index', args));
	},

	CreateTenantInvitations: async ({ tenant, data }) => {
		tenant = tenant || _tenant().slug
		data.type = 'individual'
		return await api().post(getRoute('api.invitations.store', { tenant }), obj.objToFormData(data));
	},

	CreateBulkTenantInvitations: async ({ tenant, emails }) => {
		tenant = tenant || _tenant().slug
		let data = { type: 'bulk', emails: emails };
		return await api().post(getRoute('api.invitations.store', { tenant }), obj.objToFormData(data));
	},

	UpdateBulkTenantInvitations: async ({ tenant, data }) => {
		tenant = tenant || _tenant().slug
		data._method = 'PATCH'
		data.type = 'individual'
		return await api().post(getRoute('api.invitations.update', { tenant }), obj.objToFormData(data));
	},

	ResendTenantInvitation: async ({ tenant, invitation }) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.invitations.resend', { tenant, invitation }));
	},

	DeleteTenantInvitation: async ({ tenant, invitation }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.invitations.destroy', { tenant, invitation }));
	},

	DeleteAllTenantInvitations: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.invitations.destroyAll', { tenant }));
	}
}

export const IntegrationRoutes = {

	GetAllAvailable: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.integrations.index', { tenant }))
	},
	GetAllForTenant: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.activeIntegrations.index', { tenant }))
	},
	RemoveActiveForTenant: async ({ tenant, integration }) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api.activeIntegrations.destroy', { tenant, integration }))
	},
	HubspotPipelines: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.pipelines', { tenant }));
	},
	HubspotCallStatuses: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.call.statuses', { tenant }));
	},
	HubspotCallDirections: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.call.directions', { tenant }));
	},
	HubspotCallOutcomes: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.call.outcomes', { tenant }));
	},
	HubspotActivityTypes: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.activity.types', { tenant }));
	},
	HubspotMeetingOutcomes: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.hubspot.meeting.outcomes', { tenant }));
	},
	RefreshHubspotData: async ({ tenant, sprint, type } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api.hubspot.data.refresh', { tenant, sprint, type }));
	},
}

export const apiKeyRoutes = {

	Generate: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api-key.store', { tenant }))
	},
	Remove: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().delete(getRoute('api-key.destroy', { tenant }))
	},
	Check: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api-key.check', { tenant }))
	},
	Show: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api-key.show', { tenant }))
	},
	Update: async ({ tenant, data } = {}) => {
		tenant = tenant || _tenant().slug
		data._method = 'PATCH'
		return await api().post(getRoute('api-key.update', { tenant }), data)
	},
	Rotate: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().post(getRoute('api-key.rotate', { tenant }))
	}
}

export const ExchangeRateRoutes = {
	ExchangeRates: async ({ tenant } = {}) => {
		tenant = tenant || _tenant().slug
		return await api().get(getRoute('api.exchangeRates', { tenant }));
	}
}
